import { render } from "./TopBlockCard.vue?vue&type=template&id=40fc826a&scoped=true"
import script from "./TopBlockCard.vue?vue&type=script&lang=js"
export * from "./TopBlockCard.vue?vue&type=script&lang=js"

import "./TopBlockCard.vue?vue&type=style&index=0&id=40fc826a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40fc826a"]])

export default __exports__